const FILTER_OPTION_IMAGE_TYPE_ID = {
  value: '1',
  label: '固件类型ID',
};
const FILTER_OPTION_MODEL = {
  value: '2',
  label: '对应型号',
};
const FILTER_OPTION_HEX = {
  value: '3',
  label: '类型编码',
};
const FILTER_OPTIONS = [FILTER_OPTION_IMAGE_TYPE_ID, FILTER_OPTION_MODEL, FILTER_OPTION_HEX];
const columns = [
  {
    title: '固件类型ID',
    dataIndex: 'imageTypeId',
    key: 'imageTypeId',
    align: 'center',
  },
  {
    title: '对应型号',
    dataIndex: 'modelIdentifiers',
    key: 'modelIdentifiers',
    scopedSlots: { customRender: 'modelIdentifiers' },
    align: 'center',
  },
  {
    title: '类型编码',
    dataIndex: 'imageTypeHex',
    key: 'imageTypeHex',
    align: 'center',
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    align: 'center',
    width: '15%',
  },
  {
    title: '创建时间',
    dataIndex: 'createdTime',
    key: 'createdTime',
    scopedSlots: { customRender: 'createTime' },
    align: 'center',
  },
  {
    title: '更新人',
    dataIndex: 'updaterName',
    key: 'updaterName',
    align: 'center',
  },
  {
    title: '最后修改时间',
    dataIndex: 'lastModificationTime',
    key: 'lastModificationTime',
    scopedSlots: { customRender: 'lastModificationTime' },
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    align: 'center',
  },
];

export default {
  columns,
  FILTER_OPTIONS,
  FILTER_OPTION_IMAGE_TYPE_ID,
  FILTER_OPTION_MODEL,
  FILTER_OPTION_HEX,
};
